var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCryptoImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 260,
    viewBox: "0 0 351 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_6494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.0477 178.75L246.478 289.018H-48.3828L99.0477 178.75Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.679 191.131L405.109 301.399H110.248L257.679 191.131Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.655 171.012L323.085 281.28H28.2242L175.655 171.012Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.655 171.012L323.085 281.28H28.2242L175.655 171.012Z",
    fill: "url(#paint0_linear_155_6494)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.814 55.7143V160.819H171.367C149.211 160.819 131.249 137.289 131.249 108.267C131.249 79.2437 149.211 55.7143 171.367 55.7143H179.814Z",
    fill: "#EAB308"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.11 126.565C134.473 127.843 134.878 129.092 135.312 130.319H180.177V126.565H134.11Z",
    fill: "#FEF9C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.087 136.89C138.728 138.18 139.411 139.432 140.136 140.644H180.177V136.89H138.087Z",
    fill: "#FEF9C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.066 116.243C132.213 117.512 132.407 118.76 132.623 119.997H180.177V116.243H132.066Z",
    fill: "#FEF9C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144.79 147.212C145.904 148.531 147.093 149.784 148.353 150.966H180.177V147.212H144.79Z",
    fill: "#FEF9C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M180.177 158.942V155.188H153.679C155.998 156.733 158.495 157.994 161.116 158.942H180.177Z",
    fill: "#FEF9C3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.787 95.5991C132.554 96.8258 132.358 98.0845 132.193 99.3505H180.177V95.5991H132.787Z",
    fill: "#FEF9C3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.651 105.921C131.627 106.699 131.607 107.479 131.607 108.267C131.607 108.738 131.624 109.204 131.634 109.675H180.177V105.921H131.651Z",
    fill: "#FEF9C3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M164.195 56.6518C161.013 57.4531 157.965 58.718 155.151 60.4057H180.177V56.6518H164.195Z",
    fill: "#FEF9C3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M149.366 64.6307C148.041 65.8042 146.789 67.0579 145.617 68.3846H180.177V64.6307H149.366Z",
    fill: "#FEF9C3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M140.7 74.9527C139.944 76.1599 139.229 77.4112 138.555 78.7066H180.177V74.9527H140.7Z",
    fill: "#FEF9C3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.646 85.2747C135.189 86.5015 134.777 87.7553 134.394 89.0286H180.177V85.2747H135.646Z",
    fill: "#FEF9C3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.047 160.819C202.204 160.819 220.165 137.29 220.165 108.267C220.165 79.2427 202.204 55.7143 180.047 55.7143C157.891 55.7143 139.929 79.2427 139.929 108.267C139.929 137.29 157.891 160.819 180.047 160.819Z",
    fill: "#EAB308"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M180.047 151.903C197.281 151.903 211.251 132.366 211.251 108.267C211.251 84.1673 197.281 64.6307 180.047 64.6307C162.814 64.6307 148.843 84.1673 148.843 108.267C148.843 132.366 162.814 151.903 180.047 151.903Z",
    fill: "#FEF9C3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M196.219 116.617C196.364 111.942 194.225 108.848 190.984 107.51C193.389 106.092 195.054 103.42 195.164 99.7234C195.304 95.1291 192.847 91.7908 188.035 90.5496L188.212 84.8766L182.973 84.7097L182.802 89.9835L179.827 89.8898L179.998 84.616L174.764 84.4497L174.593 89.7235L169.822 89.5762L166.499 89.4732L166.332 94.7121L169.655 94.8151L168.882 120.299L165.211 120.181L165.044 125.42L168.715 125.533L173.486 125.68L173.3 131.812L178.534 131.979L178.725 125.847L181.7 125.94L181.509 132.072L186.748 132.239L186.94 125.905C192.874 125.265 196.051 121.942 196.219 116.617ZM176.305 95.0318L183.396 95.2493C187.329 95.37 189.509 97.0829 189.409 100.422C189.309 103.761 187.028 105.28 183.087 105.178L175.019 104.926L175.32 95.0165L176.305 95.0318ZM183.743 120.755L175.171 120.489L174.565 120.472L174.886 110.099L184.074 110.383C188.355 110.513 190.627 112.177 190.515 115.768C190.403 119.358 188.045 120.888 183.743 120.755Z",
    fill: "#EAB308"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_155_6494",
    x1: 175.655,
    y1: 171.012,
    x2: 175.655,
    y2: 230.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD5E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_6494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350.536,
    height: 198.095,
    fill: "white",
    transform: "translate(0 30.9524)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoImage);
export default __webpack_public_path__ + "static/media/crypto_image.6833c436294cd27873e3903f2b466ba4.svg";
export { ForwardRef as ReactComponent };